import cn from 'classnames'
import styles from './Spinner.module.css'
import { useEffect, useState } from 'react';
export const Spinner = ({state}) => {
      const [style,setStyle] = useState(null);
        useEffect(() => {
          if(document.body.getAttribute('data-theme', 'light')) {
            setStyle('light');
          }
        }, []);
  return (
    <div className={cn(styles.spinner,
      state==='opacity' && styles.opacity,
      style==='light' && styles.light
    ) }>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
        width="100px" height="100px" viewBox="0 0 512 512"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0, 512) scale(0.1, -0.1)"
          fill="#7B35FE" stroke="none">

          <path d="M2456 4385 c-78 -30 -134 -83 -174 -165 -21 -43 -26 -70 -26 -125 0
                -119 60 -215 169 -273 43 -23 62 -27 135 -27 73 0 92 4 136 27 147 77 210 253
                142 398 -30 66 -84 121 -147 152 -58 28 -177 35 -235 13z"/>
          <path d="M1697 4156 c-228 -82 -249 -403 -34 -513 106 -53 224 -39 313 40 191
                168 73 487 -181 486 -33 0 -77 -6 -98 -13z"/>
          <path d="M3311 3906 c-16 -19 -6 -36 20 -36 15 0 20 6 17 22 -4 27 -21 33 -37
                14z"/>
          <path d="M1132 3565 c-175 -76 -213 -307 -69 -430 132 -113 334 -64 402 98 19
                46 20 147 1 191 -20 49 -85 116 -131 137 -49 22 -156 24 -203 4z"/>
          <path d="M3855 3360 c-15 -16 -17 -26 -9 -48 17 -50 94 -39 94 14 0 49 -52 70
                -85 34z"/>
          <path d="M921 2764 c-168 -84 -167 -324 2 -409 86 -42 179 -30 249 33 53 48
                78 102 78 172 0 172 -175 280 -329 204z"/>
          <path d="M4058 2625 c-51 -28 -50 -103 2 -130 36 -19 75 -11 95 18 47 68 -26
                151 -97 112z"/>
          <path d="M1178 1990 c-78 -24 -138 -92 -152 -170 -14 -80 39 -172 121 -214 63
                -31 166 -14 221 37 69 64 83 187 29 264 -46 67 -149 106 -219 83z"/>
          <path d="M3819 1861 c-20 -20 -29 -40 -29 -61 0 -85 76 -133 150 -95 91 47 53
                185 -50 185 -33 0 -48 -6 -71 -29z"/>
          <path d="M1732 1396 c-77 -27 -133 -122 -117 -197 17 -82 97 -149 176 -149 50
                1 112 33 144 74 73 95 23 243 -93 276 -46 12 -68 12 -110 -4z"/>
          <path d="M3293 1353 c-34 -7 -81 -59 -89 -99 -15 -81 42 -149 126 -149 40 0
                54 5 79 29 74 71 52 180 -42 215 -29 11 -35 12 -74 4z"/>
          <path d="M2495 1160 c-54 -28 -78 -63 -82 -124 -5 -65 19 -113 73 -143 48 -28
                93 -29 143 -3 57 29 84 78 79 144 -5 63 -29 99 -84 126 -51 25 -79 25 -129 0z"/>
        </g>
      </svg>
    </div>

  )
}